/**
 * Global state for FileExplorer component synchronization
 * Shared across all FileExplorer instances to prevent duplicate processing
 *
 * Uses window object for true global state
 */

// Use window object to ensure true global state across all module instances
declare global {
  interface Window {
    __fileExplorerState?: {
      isProcessingRename: boolean
      skipNextRebuild: boolean
      resetTimeoutId: number | null
      lastRenameTimestamp: number  // Timestamp of last rename operation
      lastRenamedOldPath: string | null
      lastRenamedNewPath: string | null
    }
  }
}

// Initialize global state if not exists
if (typeof window !== 'undefined' && !window.__fileExplorerState) {
  window.__fileExplorerState = {
    isProcessingRename: false,
    skipNextRebuild: false,
    resetTimeoutId: null,
    lastRenameTimestamp: 0,
    lastRenamedOldPath: null,
    lastRenamedNewPath: null
  }
}

// Export state accessor
export const state = typeof window !== 'undefined'
  ? window.__fileExplorerState!
  : {
      isProcessingRename: false,
      skipNextRebuild: false,
      resetTimeoutId: null,
      lastRenameTimestamp: 0,
      lastRenamedOldPath: null,
      lastRenamedNewPath: null
    }

// Reset both flags after a delay (used after file rename)
export function resetRenameFlags(delay: number = 300) {
  const globalState = state

  // Clear any existing timeout
  if (globalState.resetTimeoutId !== null) {
    clearTimeout(globalState.resetTimeoutId)
  }

  globalState.resetTimeoutId = window.setTimeout(() => {
    globalState.isProcessingRename = false
    globalState.skipNextRebuild = false
    globalState.resetTimeoutId = null
    console.log('[fileExplorerState] Flags reset to false')
  }, delay)
}

// Cancel pending reset (used on component destroy)
export function cancelResetRenameFlags() {
  const globalState = state
  if (globalState.resetTimeoutId !== null) {
    clearTimeout(globalState.resetTimeoutId)
    globalState.resetTimeoutId = null
  }
}
